import React from 'react';
import { Box, IconButton } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserPlus, faCamera } from '@fortawesome/pro-solid-svg-icons';
import { lightBackground1, lightBlack, lightGrey } from '../../../mainTheme';

export const ProfileAvatar = ({ photo, onAddPhoto }: any) => {
  return (
    <Box sx={{ textAlign: 'center' }}>
      <Box
        sx={{
          position: 'relative',
          width: '64px',
          height: '64px',
          margin: '0 auto',
        }}
      >
        <Box
          sx={{
            width: '100%',
            height: '100%',
            borderRadius: '50%',
            overflow: 'hidden',
            backgroundColor: '#F6F6F9',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: '1px solid #D4D4D9',
          }}
        >
          {photo ? (
            <img
              src={photo}
              alt="Profile"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
              }}
            />
          ) : (
            <FontAwesomeIcon
              icon={faUserPlus}
              style={{
                color: lightGrey,
                width: '38px',
                height: '38px',
                marginLeft: 6,
              }}
            />
          )}
        </Box>
        <IconButton
          size="small"
          sx={{
            width: '24px',
            height: '24px',
            position: 'absolute',
            bottom: 0,
            right: 0,
            backgroundColor: lightBlack,
            color: 'white',
            '&:hover': {
              backgroundColor: 'primary.dark',
            },
          }}
          onClick={onAddPhoto}
        >
          <FontAwesomeIcon
            icon={faCamera}
            style={{
              width: '12px',
              height: '12px',
              color: lightBackground1,
            }}
          />
        </IconButton>
      </Box>
    </Box>
  );
};
